import { View } from "react-native";
import React from "react";
import { EventDetails, GroupTicketDetails } from "features/types";
import GuestTicketRenderItem from "./GuestTicketRenderItem";
import { Swiper, SwiperSlide } from "components/Swiper";
export interface GuestsCarouselProps {
  guestTickets: GroupTicketDetails[];
  event: EventDetails;
}

const GuestsCarousel: React.FC<GuestsCarouselProps> = (props) => {
  const { guestTickets, event } = props;

  return (
    <View style={{ overflow: "hidden" }}>
      <Swiper
        style={{ width: "100%" }}
        slidesPerView={2}
        centeredSlides
        spaceBetween={15}
      >
        {guestTickets.map((ticket) => (
          <SwiperSlide key={ticket.id}>
            <GuestTicketRenderItem groupTicket={ticket} event={event} />
          </SwiperSlide>
        ))}
      </Swiper>
    </View>
  );
};

export default GuestsCarousel;
